import apuLogo from "./apu_logo.png";
import banner from "./banner.png";
import signupbanner from "./signupbanner.jpg"
import apuLogo1 from "./apu_logo1.png"
import notificationicon from "./notifyicon.png"
import apubanner from "./apu_banner.jpg"
import usericon from "./usericon.png"

export { apuLogo, banner, signupbanner, apuLogo1, notificationicon, apubanner,usericon}